import { render, staticRenderFns } from "./ValidationModal.vue?vue&type=template&id=8c04651a&scoped=true"
import script from "./ValidationModal.vue?vue&type=script&lang=js"
export * from "./ValidationModal.vue?vue&type=script&lang=js"
import style0 from "./ValidationModal.vue?vue&type=style&index=0&id=8c04651a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c04651a",
  null
  
)

export default component.exports